import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2, CheckCircle2, Database, Trash2 } from "lucide-react";
import LegalPageLayout from "../components/LegalPageLayout";
import { api, errMsg } from "../lib/api";

const SECTIONS = [
  { icon: Database, title: "What we delete", points: [
    "Your account, profile, all projects, chat history, every version and any published sites.",
    "Your encrypted GitHub token and credit balance. Payment records required by Indian tax law are kept for the legally required period.",
  ] },
  { icon: Trash2, title: "How it works", points: [
    "Submit the form below with your account email. You'll receive a confirmation code.",
    "We process requests within 7 days. Deleted data cannot be recovered.",
  ] },
];

export default function DataDeletion() {
  const [email, setEmail] = useState("");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [code, setCode] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const r = await api.requestDataDeletion({ email, reason }); setCode(r.confirmation_code || "submitted"); } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <LegalPageLayout badge="Privacy" title="Delete your data" subtitle="You can ask us to permanently delete your Ishukart account and everything in it." sections={SECTIONS}>
      <div className="rounded-2xl border border-slate-200/80 bg-white p-6 sm:p-8">
        {code ? (
          <div className="flex items-center gap-3 text-emerald-700" data-testid="deletion-success"><CheckCircle2 /> Request received. Confirmation code: <span className="font-mono text-slate-900">{code}</span></div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="deletion-form">
            <input required type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Account email" data-testid="deletion-email-input"
              className="w-full h-11 px-3.5 rounded-lg bg-slate-50 border border-slate-200 text-sm text-slate-800 outline-none focus:border-sky-400" />
            <textarea rows={3} value={reason} onChange={(e) => setReason(e.target.value)} placeholder="Reason (optional)" data-testid="deletion-reason-input"
              className="w-full px-3.5 py-3 rounded-lg bg-slate-50 border border-slate-200 text-sm text-slate-800 outline-none focus:border-sky-400" />
            <button type="submit" disabled={busy} data-testid="deletion-submit-btn" className="h-11 px-6 rounded-lg bg-rose-600 text-white text-sm font-semibold hover:bg-rose-500 flex items-center gap-2">
              {busy && <Loader2 size={15} className="animate-spin" />} Request deletion
            </button>
          </form>
        )}
      </div>
    </LegalPageLayout>
  );
}
